import { ThemeIconSizeVariable } from '@caspeco/casper-ui-library.base-ui.theme';
import { isValidElement } from 'react';
export const IconSizeConstants = {
    md: ThemeIconSizeVariable.Small,
    sm: ThemeIconSizeVariable.XSmall,
};
export const checkChildRendersToString = (child) => {
    if (typeof child === 'string') {
        return true;
    }
    if (isValidElement(child)) {
        return checkChildRendersToString(child.props.children);
    }
    if (Array.isArray(child)) {
        return child.every((subChild) => checkChildRendersToString(subChild));
    }
    return false;
};
//# sourceMappingURL=badge.helper.js.map